// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import ReservedProducts from 'Containers/ReservedProducts/ReservedProducts';

const StyledReservedProductsPage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const ReservedProductsPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let reservedProductsPageClassNames = bodyAttributes?.class || '';
  if (!reservedProductsPageClassNames.includes('ReservedProductsPage')) {
    reservedProductsPageClassNames += 'ReservedProductsPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.reservedProducts') }</title>
        <body className={ reservedProductsPageClassNames } />
      </Helmet>
      <StyledReservedProductsPage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <ReservedProducts />
      </StyledReservedProductsPage>
    </>
  );
});

ReservedProductsPage.displayName = 'ReservedProductsPage';

export default ReservedProductsPage;
